(function() {
  vtex.define('shipping/script/mixin/withImplementedCountries',[], function() {
    return function() {
      return this.isCountryImplemented = function(country) {
        return country === 'ARG' || country === 'BOL' || country === 'BRA' || country === 'CAN' || country === 'CHL' || country === 'COL' || country === 'CRI' || country === 'ECU' || country === 'ESP' || country === 'FRA' || country === 'GBR' || country === 'GTM' || country === 'KOR' || country === 'MEX' || country === 'PAN' || country === 'PER' || country === 'PRT' || country === 'PRY' || country === 'ROU' || country === 'URY' || country === 'USA' || country === 'VEN';
      };
    };
  });

}).call(this);

